export const ENABLE_REDEMPTION_FLOW_CONFIG_IN_PROD_UNCONDITIONALLY = false;
export const ENABLE_REDEMPTION_FLOW_CONFIG_IN_PROD_AFTER = new Date('2024-05-06 06:00');
export const CARDS_ALLOWED_TO_USE_REDEMPTION_FLOW_CONFIG_IN_PROD = [
    // JC Cards
    '82089151', '81047991', '81047994',
    // Melissa Cards
    '82331745', '81041285', '81047997',
    // Ana Cards
    '82000126',
    // Other Cards
    '82394891',
];
